/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestGetTaskProgressRequest
 */
export interface RequestGetTaskProgressRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestGetTaskProgressRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestGetTaskProgressRequest interface.
 */
export function instanceOfRequestGetTaskProgressRequest(value: object): value is RequestGetTaskProgressRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestGetTaskProgressRequestFromJSON(json: any): RequestGetTaskProgressRequest {
    return RequestGetTaskProgressRequestFromJSONTyped(json, false);
}

export function RequestGetTaskProgressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestGetTaskProgressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
    };
}

export function RequestGetTaskProgressRequestToJSON(json: any): RequestGetTaskProgressRequest {
    return RequestGetTaskProgressRequestToJSONTyped(json, false);
}

export function RequestGetTaskProgressRequestToJSONTyped(value?: RequestGetTaskProgressRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
    };
}

